import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_161: DocMigration = {
  maxSchemaVersion: "0.0.161",
  description: "Window refactor: pull operation type out of window mullion setting, rename mullions to grids",
  apply(json: any) {
    const windowsWithOperationType = [
      "T2620",
      "T3620",
      "T3010",
      "T2010",
      "T4010",
      "T5010",
      "T6010",
      "T6020",
      "T8010",
      "T2020",
      "T2020_LOW",
      "G1620",
      "G2020",
      "D1",
    ];

    //setting updates
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      //catalog windows updates
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const typeId in setting.windowTypes) {
          const window = setting.windowTypes[typeId];
          //set operation type to mullion operation type or double_hung if undefined
          if (window.operationType === undefined) {
            let operationType = "DOUBLE_HUNG";
            if (window.mullions?.operationType !== undefined) {
              operationType = window.mullions.operationType;
              delete window.mullions.operationType;
            }
            window.operationType = operationType;
          } else {
            windowsWithOperationType.push(window.id);
          }
          //rename mullion type
          renameMullionType(window);
        }
      }

      //mullion setting updates
      if (setting.type === "WINDOW_MULLION_SETTINGS") {
        if (setting.mullionType === "GRID") {
          setting.mullionType = "ORTHOGONAL";
        }
      }
    }

    //window window updates
    for (const roomLayoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[roomLayoutId];
      const openingPatterns = roomLayout.openingPatterns;
      for (const patternId in openingPatterns) {
        const openingPattern = openingPatterns[patternId];
        for (const openingId in openingPattern.openings) {
          const window = openingPattern.openings[openingId];
          if (window.type === "WINDOW") {
            //set operation type to mullion operation type
            if (window.mullions?.operationType !== undefined) {
              //if the window descriptor has an operation type, don't put an override onto the window instance
              replaceOperationType(windowsWithOperationType, window);
              delete window.mullions?.operationType;
            }
            //rename mullion type
            renameMullionType(window);
          }
        }
      }
    }

    //gable window updates
    for (const gableOpeningId in json.gableOpenings) {
      const gableOpening = json.gableOpenings[gableOpeningId];
      if (gableOpening.mullions?.operationType !== undefined) {
        replaceOperationType(windowsWithOperationType, gableOpening);
        delete gableOpening.mullions?.operationType;
      }
      //rename mullion type
      renameMullionType(gableOpening);
    }

    //dormer window updates
    for (const dormerId in json.dormers) {
      const dormer = json.dormers[dormerId];

      if (dormer.mullions?.operationType !== undefined) {
        replaceOperationType(windowsWithOperationType, dormer);
        delete dormer.mullions?.operationType;
      }
      //rename mullion type
      renameMullionType(dormer);
    }

    return json;
  },
};

export default migration_0_0_161;

function replaceOperationType(windowsWithOperationType: string[], window: any) {
  if (!windowsWithOperationType.includes(window.windowType)) {
    const openingOperationType = window.mullions?.operationType;
    if (openingOperationType) {
      window.operationType = openingOperationType;
    }
  }
}

function renameMullionType(window: any) {
  if (window.mullions?.mullionType === "GRID") {
    window.mullions.mullionType = "ORTHOGONAL";
  }
}
